import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Carousel from "../LayoutFactory/layouts/Carousel/component";
import { useDispatch, useSelector } from "react-redux";
import { fetch_sectional_content_graphql } from "../../actions/SectionalContent/dispatchers";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { CAROUSEL } from "../LayoutFactory/constants";
export function Slider({ header = "", itemCount, section }) {
    const sectionalContent = useSelector((state) => state.sectionalContent);
    const path = useSelector((state) => state.app.path);
    const dispatch = useDispatch();

    const [carouselItems, setCarouselItems] = useState([]);

    useEffect(() => {
        dispatch(fetch_sectional_content_graphql(section, itemCount));
    }, [path]);

    const sectionalData = sectionalContent[section];
    useEffect(() => {
        if (sectionalData?.sectionList) {
            setCarouselItems(
                transformForLayouts(
                    sectionalData.sectionList,
                    { name: CAROUSEL },
                    path
                )
            );
        }
    }, [sectionalData?.sectionList]);

    const carouselLayoutProps = { carouselTitle: header };
    const instance = header.replace(/ Video/g, "");
    const featureAttributionData = {
        instance: instance,
    };

    return (
        <Carousel
            layout={carouselLayoutProps}
            items={carouselItems}
            featureAttributionData={featureAttributionData}
        />
    );
}

Slider.propTypes = {
    header: PropTypes.string,
};

export default Slider;
